import * as Bixby from '$/core';

export abstract class DocumentsClientService {
  private static baseUrl = `${Bixby.Constants.API_DOCUMENTSCONTROLLER}`;

  public static async getDocumentCategories(): Promise<Bixby.Models.CompanyDocumentCategory[]> {
    const url = `${DocumentsClientService.baseUrl}/${Bixby.Constants.API_ACTION_CATEGORIES}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }

  public static async getDocumentsByCompanyId(companyId: string): Promise<Bixby.Models.CompanyDocument[]> {
    const url = `${DocumentsClientService.baseUrl}/portal/${Bixby.Constants.API_ACTION_COMPANY}/${companyId}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }

  public static async searchDocuments(
    companyId: string,
    query: Bixby.Models.CompanyDocumentSearchQuery
  ): Promise<Bixby.Models.CompanyDocument[]> {
    const url = `${DocumentsClientService.baseUrl}/${Bixby.Constants.API_ACTION_COMPANY}/${companyId}/${Bixby.Constants.API_ACTION_SEARCH}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.post(route, query);
  }

  public static async downloadDocument(documentId: string): Promise<Bixby.Models.FileResultMetadata> {
    const url = `${DocumentsClientService.baseUrl}/portal/${documentId}/${Bixby.Constants.API_ACTION_DOWNLOAD}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.getFileWithMetadata(route);
  }

  public static async downloadSelectedDocuments(documentIds: string[]): Promise<Bixby.Models.FileResultMetadata> {
    const url = `${DocumentsClientService.baseUrl}/portal/company/${Bixby.Constants.API_ACTION_DOWNLOAD_MULTIPLE}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const request = {
          companyDocumentIds: documentIds,
        };
    
    const formData = new FormData();
    formData.set('request', JSON.stringify(request));
    return await Bixby.API.postFileWithMetadata(route, formData);
  }

  public static async downloadAllAsZip(companyId: string) {
    const url = `${DocumentsClientService.baseUrl}/portal/${Bixby.Constants.API_ACTION_COMPANY}/${companyId}/${Bixby.Constants.API_ACTION_DOWNLOAD_ZIP}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.getFileWithMetadata(route);
  }

  public static async getCompanyDocumentUploadByEmailId(companyId: string, emailId: string): Promise<Bixby.Models.CompanyDocumentUploadEmailId> {
    const url = `${DocumentsClientService.baseUrl}/${Bixby.Constants.API_ACTION_COMPANY}/${companyId}/${Bixby.Constants.API_ACTION_TRANSCRIPT_UPLOAD}/${emailId}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }
}
